import { render, staticRenderFns } from "./setFirstName.vue?vue&type=template&id=18437931&scoped=true&"
import script from "./setFirstName.vue?vue&type=script&lang=js&"
export * from "./setFirstName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18437931",
  null
  
)

export default component.exports